//#region imports
import { Injectable } from '@angular/core';
import { SaveDialogComponent } from '../shared/components/dialogs/save-dialog/save-dialog.component';
import { MatSnackBar, MatSnackBarConfig, MatDialog, MatDialogConfig } from '@angular/material';
import { DialogComponent } from '../shared/components/dialogs/dialog/dialog.component';
import { TranslateService } from '@ngx-translate/core';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  //#region variables
  information: any;
  //#endregion

  //#region methods
  constructor(
    public snackbar: MatSnackBar, private matDialog: MatDialog,
    private translate: TranslateService) { }

  error(message) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['background-red'];
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 10000;
    this.snackbar.open(message, 'x', config);
  }

  openDialog(selectedValue: string) {
    this.information = this.translate.instant(selectedValue);
    const infodialogConfig = new MatDialogConfig();
    infodialogConfig.panelClass ='safari-only';
    infodialogConfig.width = '250px';
    infodialogConfig.data = { name: this.information };
    this.matDialog.open(DialogComponent, infodialogConfig);
  }

  saveDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    this.matDialog.open(SaveDialogComponent, dialogConfig);
  }
  //#endregion
}
